<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>我的KPI</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <MyKPIList :pt="0"></MyKPIList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <MyKPIList :pt="1"></MyKPIList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import MyKPIList from "../KPI/MyKPIList";
export default {
  data() {
    return {
      activeName: "month",
    };
  },
  components: {
    MyKPIList
  }
}
</script>
